import { Product } from '@/api/ProductApi';
import { CreatorState } from '@/types/creator';

export function getAvailableAttributes(products: Product[]) {
	const available: CreatorState['availableAttributes'] = [];

	for (const product of products) {
		for (const attributeValue of product.attributeValues) {
			const attribute = available.find(
				(attr) => attr.id === attributeValue.attribute.id
			);

			if (!attribute) {
				available.push({
					...attributeValue.attribute,
					attributeValues: [attributeValue],
					filteredValues: [{ ...attributeValue, disabled: false }],
				});
				continue;
			}

			if (
				attribute.attributeValues.some((attr) => attr.id === attributeValue.id)
			)
				continue;

			attribute.attributeValues.push(attributeValue);
			attribute.filteredValues.push({ ...attributeValue, disabled: false });
		}
	}

	for (const attribute of available) {
		attribute.attributeValues.sort((a, b) => a.listOrder - b.listOrder);
	}
	available.sort((a, b) => a.listOrder - b.listOrder);

	return available;
}
